import React, { useState } from "react";
import { useDimensions } from "../../Util";
import ContentWithLineLimit from "../../UtilComps/ContentWithLineLimit";
import { useNavigate } from "react-router-dom";


const AddictionCard = ({ id, image, text, tagLine,penalty,punishment,question,type}) => {

    const { w, h } = useDimensions();
    const navigate = useNavigate();
    const[showPopup,setShowPopup]=useState(false);

    const bgColor="#393E46"
    const dheight="15%"
    const dwidth="100%"
    const mheight="35%"
    const mwidth="46%"
    const mimageSize=8 * h
    const dimageSize=10 * h

    const rectangleContainer = {
        width: w > h ? dwidth : mwidth,
        height: w > h ? dheight : mheight,
        background: bgColor,
        marginBottom: "7px",
        marginInline: "3.5px",
        boxSizing: "border-box",
        direction:"ltr",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        cursor:"pointer",
    }
    const rectangleContainerMob = {
        width: w > h ? dwidth : mwidth,
        height: w > h ? dheight : mheight,
        background: bgColor,
        marginBottom: "7px",
        marginInline: "3.5px",
        boxSizing: "border-box",
        direction:"ltr",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        cursor:"pointer",
        flexDirection:"column"
    }
    const imageStyle = {
        width: w > h ? dimageSize : mimageSize,
        height: w > h ? dimageSize : mimageSize,
        margin: w>h?"7px":"0px"
    }

    const imageContainer = {
        width:"40%",height:"100%",
        display:"flex",
        justifyContent:"center",
        alignItems:"center"
    }

    const contentContainer = {
        width:"60%",height:"100%",
        display:"flex",
        flexDirection:"column",
        marginInline:w,
        justifyContent:"center"
    }

    const mobileFont = {
        color:"#bebebe",
        fontSize: "clamp(11px, 1.15vh, 15px)",
        textAlign:"center"
    }
   

    const openPopup=()=>{
        navigate("/popup", {
            state: {origin:id,type:type,image:image,penalty:penalty,punishment:punishment,question:question},
        });
    }

    return <div id="addiction-card" style={w>h?rectangleContainer:rectangleContainerMob} onClick={openPopup}>
        <div id="image-container-40pr" style={imageContainer}>
            <img src={`/images/${image}`} style={imageStyle} alt="Description" />
        </div>
        {
            w>h?(
                <div id="content-container-60pr" style={contentContainer}>           
                    <ContentWithLineLimit Fontsref={w > h ? "addiction-card-text-bold-desktop" : "addiction-card-text-bold-mobile"} content={text} lineLimit={1}></ContentWithLineLimit>
                    <ContentWithLineLimit Fontsref={w > h ? "addiction-card-tagline-normal-desktop" : "addiction-card-tagline-normal-mobile"} content={tagLine} lineLimit={w>h?2:1}></ContentWithLineLimit>
            </div>
            ):(
                <div id="content-container-60pr" style={contentContainer}>   
                    <p style={mobileFont}>{text}</p>
                </div>
            )
        }
    </div>
}

export default AddictionCard;